import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BreadCrum } from './breadCrumb';

export function Banner() {

    const bannerDisplay = useSelector(state => state.banner.buttonsText) || {}
    return <div className='banner_area'>
        <div className='slb-container-fluid'>
            <Row>
            {!bannerDisplay.hideBreadcrumb && <BreadCrum />}
                <Col md={12} className="header_button DisFlex justify-content-between ">
                    <div>
                        {bannerDisplay?.tabName && <span className='banner_tabName'>
                            <h6 className="document-header-textarea">{bannerDisplay.tabName}</h6></span>}
                    </div>
                    <div>
                        {bannerDisplay?.actionsJSX}
                    </div>
                </Col>
            </Row>
        </div>
    </div>

}